import React, { useState } from 'react'
import { formatOtpInput } from '../card-details-otp.helper'

const CardDetailsVerification = ({
  updateOtp,
  otpError,
}: {
  updateOtp: (value: string) => void
  otpError: string
}) => {
  const [otp, setOtp] = useState('')

  const onOtpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target
    const { value, cursorPosition } = formatOtpInput(
      input.value,
      input.selectionStart ?? input.value.length,
    )

    // Write the formatted value back to the element before React re-renders it,
    // so re-inserting the separator does not send the cursor to the end.
    input.value = value
    input.setSelectionRange(cursorPosition, cursorPosition)

    setOtp(value)
    updateOtp(value)
  }

  return (
    <>
      <div className="card-details-info" style={{ marginBottom: '1rem' }}>
        <div>
          <i className="fas fa-info"></i>
        </div>
        <p>We have sent you a code via email. Please enter it below.</p>
      </div>

      <div className="card-details-verification-input">
        <div className="input-title">
          <p>Code*</p>
          <span>{otpError}</span>
        </div>
        <input
          type="text"
          placeholder="Enter"
          value={otp}
          autoComplete="one-time-code"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          onChange={onOtpChange}
        />
      </div>
      <p className="card-details-asterix">*Mandatory fields</p>
    </>
  )
}

export default CardDetailsVerification
